import { useEffect, useRef } from 'react'

/**
 * Lets a button's action run once until its request has settled. A mutation's `isPending` reaches
 * the button a moment after the click, so two quick clicks would send two requests; this answers
 * the second at once.
 */
export function useSubmitOnce(pending: boolean): (action: () => void) => void {
  const sent = useRef(false)
  useEffect(() => {
    if (!pending) sent.current = false
  }, [pending])
  return (action) => {
    if (sent.current) return
    sent.current = true
    action()
  }
}
